import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Home from "./components/Home";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import TopBar, { Header } from "./components/Header";
import Footer from "./components/Footer";
import ProductDetail from "./components/products/ProductDetail";
import FavoritesPage from "./components/favorites/FavoritesPage";
import CartPage from "./components/cart/CartPage";
import SuccessPage from "./components/payment/SuccessPage";
import Support from "./components/Support";
import NotFound from "./components/NotFound";
import ProductsPage from "./components/products/ProductPage";

const App: React.FC = () => {
  const { user } = useAuth();
  return (
    <AuthProvider>
      <Router>
        <TopBar />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/home" element={<Home />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/product/:brand" element={<ProductsPage />} />
          <Route
            path="/favorites"
            element={
              user ? <FavoritesPage /> : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/basket"
            element={user ? <CartPage /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/success"
            element={user ? <SuccessPage /> : <Navigate to="/login" replace />}
          />
          <Route path="/support" element={<Support />} />
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
        <Footer></Footer>
      </Router>
    </AuthProvider>
  );
};

export default App;
